import { KettleSteamOutlineIcon } from './KettleSteamOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 6D9BDFFF-63EE-45DE-A6F5-712B0EE12534
 * name kettle-steam-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle-steam-outline.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const TeaKettleEmptySteamIcon = KettleSteamOutlineIcon;
export default TeaKettleEmptySteamIcon